import { ChevronLeft, ChevronRight } from 'lucide-react'

interface PaginationReviewProps {
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
}

const PaginationReview = ({ currentPage, totalPages, onPageChange }: PaginationReviewProps) => {
  const getPages = () => {
    const pages = []
    if (currentPage > 2) pages.push(1, '...')
    if (currentPage > 1) pages.push(currentPage - 1)
    pages.push(currentPage)
    if (currentPage < totalPages) pages.push(currentPage + 1)
    if (currentPage + 1 < totalPages) pages.push('...', totalPages)
    return pages
  }

  return (
    <div className="flex justify-end items-center py-6 bg-white">
      <nav className="inline-flex gap-2" aria-label="Pagination">
        <button
          className="flex items-center justify-center w-9 h-11 rounded-xl bg-[#F3FAEB] disabled:opacity-50"
          aria-label="Previous"
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <ChevronLeft className="w-5 h-5 hover:bg-gray-200" />
        </button>
        {getPages().map((page, idx) =>
          typeof page === 'number' ? (
            <button
              key={page}
              className={`flex items-center justify-center w-9 h-11 rounded-xl font-semibold ${page === currentPage ? 'bg-[#85C349] text-white' : 'bg-[#F3FAEB] text-gray-700'}`}
              aria-current={page === currentPage ? 'page' : undefined}
              onClick={() => onPageChange(page)}
            >
              {page}
            </button>
          ) : (
            <span key={idx} className="flex items-center justify-center w-9 h-11 rounded-xl bg-white text-gray-400">...</span>
          )
        )}
        <button
          className="flex items-center justify-center w-9 h-11 rounded-xl bg-[#F3FAEB] disabled:opacity-50"
          aria-label="Next"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          <ChevronRight className="w-5 h-5 hover:bg-gray-200" />
        </button>
      </nav>
    </div>
  )
}

export default PaginationReview